import styled from 'styled-components';
import {Button} from "@mui/material";
import {tokens} from "../../../theme";

export const StyledSimpleLinkButton = styled(Button)`
    font-size: ${tokens.fontSize.xs};
`;